import { PackageTariffTypes } from "@Shared/Entities/Supplier/InstantPackage/enums";
// TODO add splits up to 60, need to do analysis first to determine it
const avgDataUsageSplits = [
    { numLines: 1, low: 1, mid: 0, high: 0, totalGb: 5 },
    { numLines: 2, low: 1, mid: 0, high: 1, totalGb: 10 },
    { numLines: 3, low: 2, mid: 0, high: 1, totalGb: 15 },
    { numLines: 4, low: 2, mid: 1, high: 1, totalGb: 20 },
    { numLines: 5, low: 3, mid: 1, high: 1, totalGb: 25 },
    { numLines: 6, low: 3, mid: 1, high: 2, totalGb: 29 },
    { numLines: 7, low: 4, mid: 1, high: 2, totalGb: 34 },
    { numLines: 8, low: 4, mid: 2, high: 2, totalGb: 39 },
    { numLines: 9, low: 4, mid: 2, high: 3, totalGb: 44 },
    { numLines: 10, low: 5, mid: 2, high: 3, totalGb: 49 },
    { numLines: 11, low: 5, mid: 3, high: 3, totalGb: 54 },
    { numLines: 12, low: 6, mid: 3, high: 3, totalGb: 58 },
    { numLines: 13, low: 6, mid: 3, high: 4, totalGb: 63 },
    { numLines: 14, low: 7, mid: 3, high: 4, totalGb: 68 },
    { numLines: 15, low: 7, mid: 4, high: 4, totalGb: 73 },
    { numLines: 16, low: 8, mid: 4, high: 4, totalGb: 78 },
    { numLines: 17, low: 8, mid: 4, high: 5, totalGb: 82 },
    { numLines: 18, low: 9, mid: 4, high: 5, totalGb: 87 },
    { numLines: 19, low: 9, mid: 5, high: 5, totalGb: 92 },
    { numLines: 20, low: 10, mid: 5, high: 5, totalGb: 97 },
    { numLines: 21, low: 10, mid: 5, high: 6, totalGb: 102 },
    { numLines: 22, low: 11, mid: 5, high: 6, totalGb: 107 },
    { numLines: 23, low: 11, mid: 6, high: 6, totalGb: 111 },
    { numLines: 24, low: 12, mid: 6, high: 6, totalGb: 116 },
    { numLines: 25, low: 13, mid: 6, high: 6, totalGb: 121 },
    { numLines: 26, low: 13, mid: 6, high: 7, totalGb: 126 },
    { numLines: 27, low: 13, mid: 7, high: 7, totalGb: 131 },
    { numLines: 28, low: 14, mid: 7, high: 7, totalGb: 136 },
    { numLines: 29, low: 15, mid: 7, high: 7, totalGb: 140 },
    { numLines: 30, low: 15, mid: 7, high: 8, totalGb: 145 },
];
export const dataLevels = {
    low: 2,
    mid: 5,
    high: 25,
};
export const getAvgDataUsageSplit = (numberLines) => {
    const split = avgDataUsageSplits.find((split) => split.numLines === numberLines);
    if (!split) {
        throw new Error(`No average data usage split found for ${numberLines} lines`);
    }
    return split;
};
export const tariffIsShared = (tariffOption) => {
    // TODO keep updated as more tariff types are added
    return tariffOption !== PackageTariffTypes.Individual;
};
